import * as React from 'react';
import { CurrentView } from '../../models/currentViewState';
import PersonaExpandedViewAsync from './personaExpandedView/personaExpandedViewAsync';
import MultiplePersonasViewAsync from './multiplePersonasView/multiplePersonasViewAsync';
import DeletedGroupViewAsync from './deletedGroupContentView/deletedGroupViewAsync';
import DistributionListViewAsync from './distributionListView/distributionListViewAsync';

export interface DataProps {
    currentView: CurrentView;
}

export default function (props: DataProps): JSX.Element {
    switch (props.currentView) {
        case CurrentView.multiplePersonas:
            return <MultiplePersonasViewAsync />;
        case CurrentView.privateDistributionList:
            return <DistributionListViewAsync />;
        case CurrentView.publicDistributionList:
        case CurrentView.person:
        case CurrentView.group:
            return <PersonaExpandedViewAsync />;
        case CurrentView.deletedGroup:
            return <DeletedGroupViewAsync />;

        default:
            return null;
    }
}
